module.exports = __webpack_public_path__ + "img/best-employee.9e926f07.png";